import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Clock, Package, ChevronLeft, RefreshCw } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { api } from '@/lib/api';

export default function AwaitingApprovalPage() {
  const navigate = useNavigate();
  const [shipments, setShipments] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    try {
      setLoading(true);
      const res = await api.get('/api/merchant-dashboard/my-pending');
      setShipments(res.data?.data || []);
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); }, []);

  return (
    <div className="p-6 space-y-6" dir="rtl">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">الشحنات بانتظار الموافقة</h1>
          <p className="text-sm text-gray-500 mt-1">الشحنات اللي سجلتها ولسه ما تمت مراجعتها من الإدارة</p>
        </div>
        <Button variant="outline" size="sm" onClick={load} className="gap-1">
          <RefreshCw className="w-4 h-4" /> تحديث
        </Button>
      </div>

      <Card>
        <CardContent className="p-0">
          <div className="overflow-x-auto">
            <table className="w-full text-right text-sm">
              <thead>
                <tr className="border-b bg-gray-50">
                  <th className="p-4 font-medium text-gray-600">رقم التتبع</th>
                  <th className="p-4 font-medium text-gray-600">المستلم</th>
                  <th className="p-4 font-medium text-gray-600">المدينة</th>
                  <th className="p-4 font-medium text-gray-600">الحالة</th>
                  <th className="p-4 font-medium text-gray-600">التاريخ</th>
                  <th className="p-4 font-medium text-gray-600"></th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr><td colSpan={6} className="p-8 text-center text-gray-400">جاري التحميل...</td></tr>
                ) : shipments.length === 0 ? (
                  <tr><td colSpan={6} className="p-8 text-center text-gray-400">
                    <Package className="w-12 h-12 text-gray-200 mx-auto mb-2" />
                    لا توجد شحنات بانتظار الموافقة
                  </td></tr>
                ) : (
                  shipments.map((s) => (
                    <tr key={s.id} className="border-b hover:bg-gray-50">
                      <td className="p-4 font-mono text-xs font-bold text-gray-900">{s.trackingNumber}</td>
                      <td className="p-4 text-gray-700">{s.receiverName}</td>
                      <td className="p-4 text-gray-500">{s.receiverCity}</td>
                      <td className="p-4">
                        <span className="inline-flex items-center gap-1 px-2.5 py-1 rounded-md text-xs font-medium bg-amber-50 text-amber-700 border border-amber-200">
                          <Clock className="w-3 h-3" /> بانتظار موافقة الإدارة
                        </span>
                      </td>
                      <td className="p-4 text-xs text-gray-500">
                        {s.createdAt ? new Date(s.createdAt).toLocaleDateString('ar-EG') : '—'}
                      </td>
                      <td className="p-4">
                        <Button variant="ghost" size="sm" className="text-orange-600 hover:text-orange-700 gap-1" onClick={() => navigate(`/shipments/${s.id}`)}>
                          التفاصيل <ChevronLeft className="w-3 h-3" />
                        </Button>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
